<template>
  <div
    class=" flex   justify-center items-center   bg-slate-300 h-[100vh]"
  >
    <v-row ref="formBox" class="flex max-w-[95%] md:max-w-[80%]  h-[100%] overflow-auto !mt-[50px]  ">
      <v-col cols="12" md="6" class="bg-white mb-10">
        <div class="">
          <div class="p-3">
            <div
              class="text-xs border bg-red-50 p-3 rounded-lg border-dashed border-red-700 text-red-700"
            >
              رانندگان عزیز برای ثبت نام بایستی از اپلیکیشن راننده استفاده کنید.
              برای دریافت لینک دانلود عدد ۱ را به شماره ۰۲۱۰۰۰۰۱۰۰ ارسال نمائید.
            </div>
          </div>
          <user v-if="formLayout === 'user'" />
          <company v-if="formLayout === 'company'" />
          <factory v-if="formLayout === 'factory'" />
          <div
            class="flex space-x-3 pb-5 py-3 text-blue-400 space-x-reverse items-center text-sm justify-center"
          >
            <button
              @click="layoutHandel('company')"
              v-if="formLayout !== 'company'"
              type="button"
            >
              ثبت نام شرکت حمل و نقل
            </button>
            <span class="text-gray-500" v-if="formLayout === 'factory'">|</span>
            <button
              @click="layoutHandel('user')"
              v-if="formLayout !== 'user'"
              type="button"
            >
              ثبت نام عادی
            </button>
            <span class="text-gray-500" v-if="formLayout !== 'factory'">|</span>
            <button
              @click="layoutHandel('factory')"
              v-if="formLayout !== 'factory'"
              type="button"
            >
              ثبت نام واحد صنفی
            </button>
          </div>
          <div class="p-4">
            <router-link to="login" class="text-sm">
              <span class="text-blue-500">حساب کاربری دارم</span>
            </router-link>
          </div>
        </div>
      </v-col>
      <v-col
        cols="6"
        style="background-color: rgba(250, 248, 253, 1)"
        class="hidden md:block mb-10"
      >
        <div class="  sticky top-[100px]">
          <img class="  max-w-[350px]  lg:max-w-[450px] m-auto" src="../../assets/login2.png" />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import user from "./user";
import company from "./company";
import factory from "./factory";
import "../../assets/styles/register.css";

export default {
  components: { user, company, factory },
  name: "registerFactory.vue",
  data() {
    return {
      formLayout: "user",
      codeBox: false,
      loading: false,
      // user
      // company
      // companyUser: false,
    };
  },
  watch: {
    formLayout() {
      this.$refs.userForm?.reset();
      this.$refs.companyUser?.reset();
      this.codeBox = false;
    },
  },
  methods: {
    layoutHandel(value) {
      this.formLayout = value;
      this.$refs.formBox.scrollTo(0, 0);
    },
  },
};
</script>

<style scoped></style>
